import { DuplicateTransactionResponse } from '@/store/transactionsApi';
import { formatNumberToCurrency } from '@/utils/currency';
import { formatAppDate } from '@/utils/date';
import { Paper, Stack, Typography, Box, Grid } from '@mui/material';
import { t } from 'i18next';

interface DuplicateTransactionCardProps {
  title: string;
  currentDuplicateSet: DuplicateTransactionResponse;
}

export const DuplicateTransactionCard = ({
  title,
  currentDuplicateSet,
}: DuplicateTransactionCardProps) => {
  return (
    <Paper
      variant='outlined'
      sx={{ p: 2.5, mb: 3, flexGrow: 1 }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        justifyContent='space-between'
        sx={{ mb: 2 }}
      >
        <Typography
          variant='subtitle1'
          sx={{ fontWeight: 600 }}
        >
          {title}
        </Typography>
      </Stack>

      <Box>
        <Grid
          container
          spacing={2}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box>
              <Typography
                variant='caption'
                color='text.secondary'
              >
                {t('DuplicateWizard.account')}
              </Typography>
              <Typography variant='body1'>
                {currentDuplicateSet.AccountName}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box>
              <Typography
                variant='caption'
                color='text.secondary'
              >
                {t('DuplicateWizard.descriptionLabel')}
              </Typography>
              <Typography variant='body1'>
                {currentDuplicateSet.Description}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box>
              <Typography
                variant='caption'
                color='text.secondary'
              >
                {t('DuplicateWizard.amount')}
              </Typography>
              <Typography variant='body1'>
                {formatNumberToCurrency(currentDuplicateSet.Amount)}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box>
              <Typography
                variant='caption'
                color='text.secondary'
              >
                {t('DuplicateWizard.date')}
              </Typography>
              <Typography variant='body1'>
                {formatAppDate(currentDuplicateSet.TransactionDate)}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
